import { DateTime } from 'luxon';
import styled from 'styled-components';

import TableLayout, {
  EmbeddedTableNullState,
  TableTD,
  TableTH,
  TableTR,
} from 'dashboard/layouts/TableLayout';
import {
  BusinessRegistration,
  ReportBusinessLookup,
} from 'dashboard/models/report/business-lookup';
import { BusinessIdentifierType } from 'dashboard/models/report/business-lookup-result-edge';
import Card from 'design-system/components/Card';
import * as Spacing from 'design-system/variables/spacing';
import { US_STATES } from 'lib/constants/locales';
import { ABBR_DATE_FORMAT } from 'lib/constants/luxonFormats';

const StickyTableTH = styled(TableTH)`
  position: sticky;
  top: 0;
`;

interface BusinessRegistrationsCardProps {
  report: ReportBusinessLookup;
}

const BusinessLookupRegistrations = ({ report }: BusinessRegistrationsCardProps) => {
  const result = report.attributes.result;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  const registrations = result.identifiers?.filter((i) => i.type !== BusinessIdentifierType.Ein);

  const body = (
    <>
      <TableLayout
        containerMaxHeight={420}
        dataTest='registrations-table'
        showHeader={true}
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        isEmpty={registrations.length === 0}
        nullState={
          <EmbeddedTableNullState
            marginVertical={Spacing.BASE * 2}
            dataTestBlock='registrations-table'
          >
            No registration records found
          </EmbeddedTableNullState>
        }
        headerTR={
          <>
            <StickyTableTH>State</StickyTableTH>
            <StickyTableTH>Registration #</StickyTableTH>
            <StickyTableTH>Issue date</StickyTableTH>
            <StickyTableTH>Registration Status</StickyTableTH>
          </>
        }
      >
        {/* @ts-expect-error [strict-migration] The following line is not strict; please fix! */}
        {registrations
          .sort((ra: BusinessRegistration, rb: BusinessRegistration) => {
            const nameA = US_STATES[ra.state as keyof typeof US_STATES];
            const nameB = US_STATES[rb.state as keyof typeof US_STATES];

            if (nameA < nameB) {
              return -1;
            } else if (nameA > nameB) {
              return 1;
            } else {
              return 0;
            }
          })
          .map((registration: BusinessRegistration) => {
            return (
              <TableTR key={`${registration.state}-${registration['file-number']}`}>
                <TableTD>{US_STATES[registration.state as keyof typeof US_STATES]}</TableTD>
                <TableTD>
                  <pre>{registration['file-number']}</pre>
                </TableTD>
                <TableTD>
                  {registration['issue-date'] != null
                    ? DateTime.fromISO(registration['issue-date']).isValid
                      ? DateTime.fromISO(registration['issue-date']).toFormat(ABBR_DATE_FORMAT)
                      : DateTime.fromMillis(Number(registration['issue-date'])).toFormat(
                          ABBR_DATE_FORMAT,
                        )
                    : null}
                </TableTD>
                <TableTD>{registration.status}</TableTD>
              </TableTR>
            );
          })}
      </TableLayout>
    </>
  );

  return (
    <>
      <Card.Title>Business Registrations</Card.Title>
      {body}
    </>
  );
};

export default BusinessLookupRegistrations;
